import {IDotRezApiService, DotRezApiTokenResult} from "./dot-rez-api.service.interface";
import {ServiceBase} from "../service-base";
import {IDotRezBookingSession} from "./session/booking-session/dot-rez-booking.session.interface";
import {DotRezBookingSession} from "./session/booking-session/dot-rez-booking.session";
import {buildFullUrl} from "../http/http-helpers";
import {DotRezBookingSessionTimerModel} from "./session/session-timer/dot-rez-booking-session-timer.model";
import {DeeplinkAgentTokenRequest} from "../airline-webapi/requests/deeplink-agent-token.request";
import {DotRezResponse} from "./session/dot-rez-response";
import {DotRezSessionExpiredException} from "./session/dot-rez-exception";
import {DotRezTransientSessionTimer} from "./session/session-timer/dot-rez-transient-session-timer";
//import {ApplicationName} from "../../global-constants";


export class DotRezApiService extends ServiceBase implements IDotRezApiService {

    buildDotRezUrl(path: string ) {
        if(!this.services.configuration.dotRezApiUrl) {
            throw new Error('dotRezApiUrl was not initialized');
        }
        return buildFullUrl(this.services.configuration.dotRezApiUrl, path);
    }

    getDotRezApiRequestHeaders(token: string): Record<string, string> {
        return {
            'Content-Type': 'application/json',
            'Authorization': token,
            ...this.services.configuration.dotRezApiSubscriptionKeyHeader
        }
    }


    async createAnonymousToken(): Promise<DotRezApiTokenResult> {
        const apiResponse = await this.services.airlineWebapi.createAnonymousDotRezToken();
        return {
            token: apiResponse.token,
            dotRezTokenExpirationDate: apiResponse.dotRezTokenExpirationDate
        };
    }

    async createDogToken(): Promise<DotRezApiTokenResult> {
        const apiResponse = await this.services.airlineWebapi.createDogToken();
        return {
            token: apiResponse.token,
            dotRezTokenExpirationDate: apiResponse.dotRezTokenExpirationDate
        };
    }

    async getDeepLinkAgentToken(request: DeeplinkAgentTokenRequest): Promise<DotRezApiTokenResult> {
        const apiResponse = await this.services.airlineWebapi.getDeepLinkAgentToken(request);
        return {
            token: apiResponse.dotRezToken,
            dotRezTokenExpirationDate: apiResponse.dotRezTokenExpirationDate
        };
    }

    get tokenApiUrlForGET(): string {
        return '/api/nsk/v1/token';
    }



    get tokenApiUrlForPUT(): string {
        return '/api/auth/v1/token/user';
    }

    async tryRefreshToken(token: string): Promise<DotRezApiTokenResult> {
        const fetchResponse = await fetch(this.buildDotRezUrl('api/auth/v1/token'), {
            method: 'PUT',
            headers: this.getDotRezApiRequestHeaders(token)
        });

        const json = await fetchResponse.json();

        const dotRezResponse = new DotRezResponse<any>(fetchResponse.status, json.data, fetchResponse.headers, json.messages, json.errors);

        if(dotRezResponse.isSessionExpired) {
            throw new DotRezSessionExpiredException();
        } else {
            dotRezResponse.throwIfError();
        }

        return {
            token: json.data.token,
            dotRezTokenExpirationDate: this.services.time.parseIsoDate(json.data.expires)
        };

    }

    async loadBookingSession(token: string): Promise<IDotRezBookingSession> {
        const refreshTokenResult = await this.tryRefreshToken(token);
        return new DotRezBookingSession(this.services, new DotRezBookingSessionTimerModel(refreshTokenResult.token, refreshTokenResult.dotRezTokenExpirationDate, this.services));
    }


    createBookingSession(token: string, expiration: Date): IDotRezBookingSession {
        return new DotRezBookingSession(this.services, new DotRezBookingSessionTimerModel(token, expiration, this.services, {disableCountDownDialog: false}));
    }

    createFlightSearchSession(token: string, expiration: Date): IDotRezBookingSession {
        return new DotRezBookingSession(this.services, new DotRezBookingSessionTimerModel(token, expiration, this.services, {disableCountDownDialog: true}));
    }

    createTransientBookingSession(token: string): IDotRezBookingSession {
        return new DotRezBookingSession(this.services, new DotRezTransientSessionTimer(token));
    }

}
